import { DataType } from '../DataType';
import { Validator } from './Parser/Visitor';
export class FTypeResolver extends Validator {
    constructor(fieldResolver, funcResolver, typeProvider) {
        super();
        this._fieldResolver = fieldResolver;
        this._funcResolver = funcResolver;
        this._typeProvider = typeProvider;
        this._stack = new Array();
        this._types = new Map();
    }
    get fieldResolver() {
        return this._fieldResolver;
    }
    get funcResolver() {
        return this._funcResolver;
    }
    get typeProvider() {
        return this._typeProvider;
    }
    get stack() {
        return this._stack;
    }
    get types() {
        return this._types;
    }
    get returnType() {
        return this.stack[0];
    }
    visitIdentifierNode(node) {
        this.pushType(node, DataType.NULL);
    }
    visitNullLiteralNode(node) {
        this.pushType(node, DataType.NULL);
    }
    visitBooleanLiteralNode(node) {
        this.pushType(node, DataType.BOOLEAN);
    }
    visitNumberLiteralNode(node) {
        this.pushType(node, DataType.NUMBER);
    }
    visitHexLiteralNode(node) {
        this.pushType(node, DataType.INTEGER);
    }
    visitStringLiteralNode(node) {
        this.pushType(node, DataType.STRING);
    }
    visitRegExpLiteralNode(node) {
        this.pushType(node, DataType.REGEXP);
    }
    visitDateLiteralNode(node) {
        this.pushType(node, DataType.DATETIME);
    }
    visitFieldLiteralNode(node) {
        this.pushField(node);
    }
    visitUnaryExpressionNode(node) {
        this.pushUnary(node);
    }
    visitBinaryExpressionNode(node) {
        this.pushBinary(node);
    }
    visitLogicalExpressionNode(node) {
        this.pushBinary(node);
    }
    visitCallExpressionNode(node) {
        this.pushCall(node);
    }
    pushType(node, dataType) {
        this.stack.push(dataType);
        if (typeof node === 'number') {
            this.types.set(node, dataType);
        }
        else {
            this.types.set(this.getNodeId(node), dataType);
        }
    }
    pushUnary(node) {
        const operand = this.stack.pop();
        switch (node.operator) {
            case 'NOT':
                this.pushType(node, DataType.BOOLEAN);
                break;
            case '-':
            case '+':
                this.pushType(node, this.typeProvider.getConvType(operand));
                break;
        }
    }
    pushBinary(node) {
        const right = this.stack.pop();
        const left = this.stack.pop();
        switch (node.operator) {
            case '+':
                this.pushType(node, this.typeProvider.getAddType(left, right));
                break;
            case '-':
            case '*':
            case '/':
            case '%':
                this.pushType(node, this.typeProvider.getMathType(left, right));
                break;
            case '=':
            case '<>':
            case '<':
            case '<=':
            case '>':
            case '>=':
            case 'AND':
            case 'OR':
                this.pushType(node, DataType.BOOLEAN);
                break;
        }
    }
    pushField(node) {
        const nodeId = this.getNodeId(node);
        const field = this.fieldResolver.getField(nodeId);
        if (field != null) {
            this.pushType(node, this.typeProvider.getFieldType(field));
        }
        else {
            this.addError(node, `Cannot determine type of unknown field ${node.value}`);
        }
    }
    pushCall(node) {
        const nodeId = this.getNodeId(node);
        const func = this.funcResolver.getFunc(nodeId);
        if (func != null) {
            const args = [];
            for (let i = 0; i < func.argc; i++) {
                args.push(this.stack.pop());
            }
            args.reverse();
            this.pushType(node, this.typeProvider.getFuncReturnType(func, args));
        }
        else {
            this.addError(node, `Cannot determine type of unknown function ${node.callee}`);
        }
    }
}
